import Amplify from "aws-amplify";
import AWS from "../../constants/aws.constant";

export const setupAmplify = () => {
  Amplify.configure(AWS);
};
